module.exports = __webpack_public_path__ + "static/media/img1.0b064f4c.jpg";